// extracted by mini-css-extract-plugin
export default {"root":"PriceRecommendation__root--F0kgw","price-large":"PriceRecommendation__price-large--C9Cdu","priceLarge":"PriceRecommendation__price-large--C9Cdu"};